import type { ButtonHTMLAttributes } from "react";
import type { LucideIcon } from "lucide-react";

type Variant = "default" | "outline" | "danger" | "ghost";

const styles: Record<Variant, string> = {
  default: "bg-sbd-black text-white dark:bg-sbd-yellow dark:text-sbd-black hover:opacity-90",
  outline: "border border-slate-300 dark:border-white/15 hover:bg-slate-100 dark:hover:bg-white/5",
  danger: "bg-red-600 text-white hover:bg-red-700",
  ghost: "text-slate-500 hover:bg-slate-100 dark:hover:bg-white/5",
};

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: Variant;
  icon?: LucideIcon;
}

export function Button({ variant = "default", icon: Icon, children, className = "", disabled, ...rest }: ButtonProps) {
  return (
    <button
      className={`text-xs font-semibold rounded-lg px-3 py-2 inline-flex items-center gap-1.5 disabled:opacity-50 disabled:cursor-not-allowed outline-none focus-visible:ring-2 focus-visible:ring-sbd-yellow/60 focus-visible:ring-offset-2 dark:focus-visible:ring-offset-surface-2 ${styles[variant]} ${className}`}
      disabled={disabled}
      {...rest}
    >
      {Icon ? <Icon className="w-3.5 h-3.5" /> : null}
      {children}
    </button>
  );
}
